module.exports = __webpack_public_path__ + "static/img/icon-mp3.76b6879f.jpg";